export default __webpack_public_path__ + "static/media/jellyfish@3x.9a4b593e.png";